import { Link } from 'react-router-dom';

const STEPS = [
  { step: '01', icon: '📱', title: 'Initiate Return', body: 'Log in to your account, go to My Orders, select the item and click "Return". Fill in the reason for return.' },
  { step: '02', icon: '📦', title: 'Pack Your Item', body: 'Pack the item securely in its original packaging with all tags intact. Download and attach the return label.' },
  { step: '03', icon: '🚚', title: 'Pickup Scheduled', body: 'Our logistics partner will schedule a pickup within 2–3 business days from your registered address.' },
  { step: '04', icon: '✅', title: 'Refund Processed', body: 'Once we receive and inspect the item, a refund is issued within 5–7 business days to your original payment method.' },
];

const POLICY = [
  { q: 'Return Window', a: '15 days from delivery date' },
  { q: 'Exchange Window', a: '15 days from delivery date' },
  { q: 'Condition Required', a: 'Unworn, unwashed, with all original tags' },
  { q: 'Free Returns', a: 'Yes, for all prepaid orders above ₹999' },
  { q: 'COD Returns', a: '₹99 return shipping fee applies' },
  { q: 'Refund Method', a: 'Original payment method or store credit' },
  { q: 'Refund Timeline', a: '5–7 business days after item received' },
  { q: 'Exchange Timeline', a: '7–10 business days for exchange delivery' },
];

const NON_RETURNABLE = [
  'Sale & clearance items (marked "Final Sale")',
  'Customized or personalized garments',
  'Innerwear and swimwear (hygiene)',
  'Items without original tags',
  'Used, washed, or damaged items',
  'Gift cards',
];

export default function Returns() {
  return (
    <div className="page-top">
      {/* Hero */}
      <div style={S.hero}>
        <div style={S.heroBg}>RETURNS</div>
        <div style={S.heroContent}>
          <p className="sec-label" style={{ color: 'var(--gold)', marginBottom: '10px' }}>Hassle-Free Policy</p>
          <h1 style={S.heroTitle}>RETURNS &amp; EXCHANGE</h1>
          <p style={S.heroSub}>We want you to love every Bhadralok piece. If it's not right, we make it right — simple, fast, no questions asked.</p>
          <div style={S.heroBadges}>
            {['15-Day Returns', 'Free Pickup', 'Fast Refund', 'Easy Exchange'].map((b) => (
              <div key={b} style={S.badge}><span style={{ color: 'var(--green)' }}>✓</span> {b}</div>
            ))}
          </div>
        </div>
      </div>

      {/* Steps */}
      <div style={S.stepsSection}>
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <p className="sec-label" style={{ marginBottom: '10px' }}>The Process</p>
          <h2 style={S.secTitle}>HOW IT <em style={{ color: 'var(--red)', fontStyle: 'italic' }}>WORKS</em></h2>
        </div>
        <div style={S.stepsGrid}>
          {STEPS.map((s) => (
            <div key={s.step} style={S.stepCard}>
              <div style={S.stepNum}>{s.step}</div>
              <div style={S.stepIcon}>{s.icon}</div>
              <h3 style={S.stepTitle}>{s.title}</h3>
              <p style={{ fontSize: '13px', color: '#666', lineHeight: 1.75 }}>{s.body}</p>
            </div>
          ))}
        </div>
        <div style={{ textAlign: 'center', marginTop: '36px' }}>
          <Link to="/dashboard" style={S.ctaBtn}>INITIATE A RETURN →</Link>
        </div>
      </div>

      {/* Policy Grid + Non-Returnable */}
      <div style={S.mainGrid}>
        <div>
          <h2 style={S.subTitle}>POLICY AT A GLANCE</h2>
          <div style={S.policyTable}>
            {POLICY.map((p) => (
              <div key={p.q} style={S.policyRow}>
                <span style={S.policyQ}>{p.q}</span>
                <span style={S.policyA}>{p.a}</span>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h2 style={S.subTitle}>NON-RETURNABLE ITEMS</h2>
          <div style={S.nonReturnCard}>
            <p style={{ fontSize: '13px', color: '#555', lineHeight: 1.7, marginBottom: '16px' }}>
              The following items are <strong>not eligible</strong> for return or exchange:
            </p>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {NON_RETURNABLE.map((item) => (
                <li key={item} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '13px', color: '#555' }}>
                  <span style={{ color: 'var(--red)', fontWeight: 700, flexShrink: 0, marginTop: '2px' }}>✗</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Help box */}
          <div style={S.helpBox}>
            <p style={{ fontFamily: 'var(--font-display)', fontSize: '15px', letterSpacing: '2px', color: '#fff', marginBottom: '8px' }}>NEED HELP?</p>
            <p style={{ fontSize: '12px', color: 'rgba(255,255,255,.5)', lineHeight: 1.7, marginBottom: '16px' }}>
              Can't find your order or facing an issue? Our team is here.
            </p>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Link to="/contact" style={S.helpCta}>Contact Us</Link>
              <Link to="/faqs" style={S.helpCtaOutline}>Read FAQs</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const S = {
  hero:          { background: 'var(--black)', padding: '60px 56px 52px', position: 'relative', overflow: 'hidden', borderBottom: '4px solid var(--gold)' },
  heroBg:        { position: 'absolute', right: '-20px', top: '50%', transform: 'translateY(-50%)', fontFamily: 'var(--font-display)', fontSize: 'clamp(60px,12vw,160px)', letterSpacing: '-4px', color: 'rgba(255,255,255,.04)', lineHeight: 1, userSelect: 'none' },
  heroContent:   { position: 'relative', zIndex: 1 },
  heroTitle:     { fontFamily: 'var(--font-display)', fontSize: 'clamp(32px,5vw,56px)', letterSpacing: '2px', color: '#fff', lineHeight: 1, marginBottom: '14px' },
  heroSub:       { fontSize: '14px', color: 'rgba(255,255,255,.5)', lineHeight: 1.8, maxWidth: '520px', marginBottom: '24px' },
  heroBadges:    { display: 'flex', gap: '12px', flexWrap: 'wrap' },
  badge:         { background: 'rgba(255,255,255,.06)', border: '1px solid rgba(255,255,255,.12)', padding: '6px 14px', fontSize: '11px', fontWeight: 700, letterSpacing: '.5px', color: 'rgba(255,255,255,.7)' },
  stepsSection:  { padding: '80px 56px', background: '#fff' },
  secTitle:      { fontFamily: 'var(--font-display)', fontSize: 'clamp(22px,3vw,36px)', letterSpacing: '2px', lineHeight: 1.1 },
  stepsGrid:     { display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '20px' },
  stepCard:      { background: 'var(--offwhite)', border: '1px solid var(--border)', padding: '28px 22px', position: 'relative' },
  stepNum:       { position: 'absolute', top: '16px', right: '16px', fontFamily: 'var(--font-display)', fontSize: '36px', letterSpacing: '2px', color: 'rgba(0,0,0,.06)', lineHeight: 1 },
  stepIcon:      { fontSize: '28px', marginBottom: '14px' },
  stepTitle:     { fontFamily: 'var(--font-display)', fontSize: '15px', letterSpacing: '1.5px', marginBottom: '10px' },
  ctaBtn:        { display: 'inline-block', background: 'var(--red)', color: '#fff', padding: '14px 36px', fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', textDecoration: 'none' },
  mainGrid:      { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', padding: '64px 56px', background: 'var(--offwhite)' },
  subTitle:      { fontFamily: 'var(--font-display)', fontSize: '16px', letterSpacing: '2.5px', marginBottom: '20px', paddingBottom: '12px', borderBottom: '2px solid var(--red)' },
  policyTable:   { background: '#fff', border: '1px solid var(--border)' },
  policyRow:     { display: 'flex', justifyContent: 'space-between', padding: '13px 18px', borderBottom: '1px solid var(--border)', fontSize: '13px' },
  policyQ:       { color: '#888', fontWeight: 500 },
  policyA:       { fontWeight: 700, color: 'var(--black)', textAlign: 'right' },
  nonReturnCard: { background: '#fff', border: '1px solid var(--border)', padding: '20px', marginBottom: '16px' },
  helpBox:       { background: 'var(--black)', padding: '20px', borderLeft: '3px solid var(--red)' },
  helpCta:       { display: 'inline-block', background: 'var(--red)', color: '#fff', padding: '9px 18px', fontSize: '11px', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', textDecoration: 'none' },
  helpCtaOutline:{ display: 'inline-block', background: 'transparent', color: 'rgba(255,255,255,.6)', border: '1px solid rgba(255,255,255,.2)', padding: '9px 18px', fontSize: '11px', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', textDecoration: 'none' },
};
